const amendmentEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/amendments` as const,
  detail: (companyId: string, amendmentId: number) => `/companies/${companyId}/amendments/${amendmentId}` as const,
  create: (companyId: string) => `/companies/${companyId}/amendments` as const
}

export default amendmentEndpoints
